import type { StyleRule } from '@archipro-design/aria';
import { dialogSlotClassNames, pxToRem } from '@archipro-design/aria';
export const SampleDialog: StyleRule = ({ theme }) => ({
    ['& .' + dialogSlotClassNames.headerAction]: {
        backgroundColor: 'transparent',
        margin: 0,
        boxShadow: 'none',
        outline: 'none',
        '&:focus': {
            outline: 'none',
        },
    },
    ['& .' + dialogSlotClassNames.footer]: {
        borderTop: `1px solid ${theme.siteVariables.colors.white[300]}`,
    },
});

export const ButtonRow: StyleRule = () => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '& button': {
        marginLeft: pxToRem(24),
    },
});
